/*jshint esversion: 8 */
function LazyStripeWrapper(publishableKey) {
  // Wrap the Stripe v2 script up to accomplish a couple of goals:
  // 1: only load it for components where it will be needed, so our SPA doesn't have stripe active all the time
  // 2: Clean up the interface a little bit, so we don't have to use callback handlers
  const getStripeObject = () => {
    window.Stripe.setPublishableKey(publishableKey);
    return {
      $orig: window.Stripe,
      // wrap up the functions we want, so we can use async\await syntax instead of callback handlers
      // this way it will fit in with the rest of our code
      createToken(number, cvv, expMonth, expYear) {
        return new Promise((resolve, reject) => {
          const responseHandler = (status, response) => {
            if (response.error) {
              reject({ status, error: response.error, response });
            } else {
              resolve({
                status,
                response: {
                  stripe_token_id: response.id || "",
                  stripe_card_id: response.card.id || "",
                  avs_zip_check:
                    response.card.address_line1_check || "unavailable",
                  avs_cvv_check:
                    response.card.address_zip_check || "unavailable",
                  avs_address_check: response.card.cvc_check || "unavailable"
                }
              });
            }
          };
          window.Stripe.card.createToken(
            {
              number: number,
              cvc: cvv,
              exp_month: expMonth,
              exp_year: expYear
            },
            100,
            responseHandler
          );
        });
      }
    };
  };

  return new Promise(resolve => {
    // Stripe doesn't like being loaded into the DOM more than once
    if (typeof window.Stripe !== "undefined") {
      resolve(getStripeObject());
    } else {
      const script = document.createElement("script");
      script.src = "https://js.stripe.com/v2/";
      script.onreadystatechange = () => resolve(getStripeObject()); // IE
      script.onload = () => resolve(getStripeObject()); // everyone else
      document.querySelector("head").append(script);
    }
  });
}

export default LazyStripeWrapper;
